import React from 'react';
import Box from '@mui/material/Box';
import SpecialtyMenu from '../components/Menu/specialtyItemTab/SpecialtyMenu';
import PageHeader from '../components/layout/PageHeader';

export default function DailySupplies() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
      <PageHeader
        title="Daily use supplies"
        subtitle="Specialty and daily-use items used across production"
      />
      <Box sx={{ flex: 1, px: { xs: 1, md: 2 }, pt: 1.5, pb: 3 }}>
        <SpecialtyMenu />
      </Box>
    </Box>
  );
}
